// styles.js — extracted from Home.jsx
export const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#000000",
    color: "#ffffff",
  },
  mainContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginLeft: "260px",
    marginRight: "0px",
    transition: "margin-right 0.3s ease",
    marginTop: "4rem",
  },
  centerArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    maxWidth: "800px",
    margin: "0 auto",
    width: "100%",
  },
  logoContainer: {
    marginBottom: "1rem",
  },
  logo: {
    width: "100px",
    height: "100px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "bold",
    color: "white",
  },
  welcomeTitle: {
    fontSize: "2rem",
    fontWeight: "600",
    color: "#ffffff",
    marginBottom: "2rem",
    textAlign: "center",
    marginTop: "-20px",
  },
  inputContainer: {
    width: "100%",
    maxWidth: "900px",
    position: "relative",
  },
  chatContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "1rem 2rem",
    maxWidth: "1050px",
    margin: "0 auto",
    width: "100%",
  },
  messageContainer: {
    marginBottom: "0.5rem",
    display: "flex",
    flexDirection: "column",
  },
  messagesArea: {
    flex: 1,
    overflowY: "auto",
    marginBottom: "1rem",
    minHeight: "400px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  userMessage: {
    marginTop: "0.5rem",
    alignSelf: "flex-end",
    backgroundColor: "#FF00AA29",
    border: "1px solid #E165BE33",
    color: "white",
    padding: "0.75rem 1rem",
    borderRadius: "12px",
    maxWidth: "70%",
    marginBottom: "0.5rem",
    fontStyle: "Inter",
    fontSize: "14px",
  },
  assistantMessage: {
    alignSelf: "flex-start",
    color: "#e5e7eb",
    padding: "0.75rem 1rem",
    borderRadius: "18px 18px 18px 4px",
    maxWidth: "80%",
  },
  systemMessage: {
    alignSelf: "center",
    backgroundColor: "#374151",
    color: "#9ca3af",
    padding: "0.5rem 1rem",
    borderRadius: "12px",
    fontSize: "0.875rem",
    marginBottom: "0.5rem",
  },
  timestamp: {
    fontSize: "0.75rem",
    color: "#6b7280",
    marginTop: "0.25rem",
  },
  statusBar: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "white",
    padding: "1rem 2rem",
    borderRadius: "8px",
    zIndex: 1000,
  },
  askDock: {
    position: "sticky",
    bottom: 0,
    padding: "10px 0 0",
    background:
      "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 30%, rgba(0,0,0,0.85) 100%)",
    backdropFilter: "blur(2px)",
  },
  progressPanel: {
    maxHeight: 200,
    width: "80%",
    overflowY: "auto",
    margin: "0 0 32px 0",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "0 4px",
  },
  suggestionsWrap: {
    width: "100%",
    maxWidth: "900px",
    marginTop: "48px",
    height: "24px",
  },
  suggestionItem: {
    padding: "14px 0",
    color: "#9D9BA1",
    cursor: "pointer",
    userSelect: "none",
  },
};

// styles.js

export const markdownStyles = {
  container: { fontSize: "14px", lineHeight: "1.5" },
  h1: { fontSize: "24px", fontWeight: "bold", marginBottom: "16px" },
  h2: { fontSize: "20px", fontWeight: "600", marginBottom: "12px" },
  p: {
    marginBottom: "12px",
    fontSize: "14px",
    fontStyle: "Inter", // Changed from fontStyle to fontStyle
  },
  code: {
    backgroundColor: "#f4f4f4",
    padding: "2px 6px",
    borderRadius: "4px",
    fontStyle: "'Courier New', monospace", // Changed from fontStyle to fontStyle
  },
  pre: {
    backgroundColor: "#f4f4f4",
    padding: "12px",
    borderRadius: "6px",
    overflowX: "auto",
  },
  ul: {
    paddingLeft: "1.25rem",
    marginBottom: "12px",
    listStyleType: "disc",
  },
  li: {
    marginBottom: "6px",
  },
  strong: {
    color: "#C80085",
    fontWeight: "bold",
  },
  a: {
    color: "#5C6BC0",
    textDecoration: "underline",
    cursor: "pointer",
  },
};
